export const UUID_SEGMENT_PATTERN =
  "[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}";

export const UUID_SEGMENT_REGEX = new RegExp(`^${UUID_SEGMENT_PATTERN}$`, "i");
